import {
  DEFAULT_SUGGEST_TOV_MODE,
  EMPTY_MANUAL_TONE_OF_VOICE,
  MANUAL_TONE_OF_VOICE_PROPS,
  PRESET_TONE_OF_VOICE,
  PRESET_TONE_OF_VOICE_PROPS,
  TONE_OF_VOICE_TYPE,
} from '.';

export const isPresetTov = (tov) => Object.values(PRESET_TONE_OF_VOICE).includes(tov);

export const getTovTexts = (tov, customToneOfVoices) => {
  if (isPresetTov(tov)) {
    return {
      tovTitle: PRESET_TONE_OF_VOICE_PROPS[tov].title,
      tovDescription: PRESET_TONE_OF_VOICE_PROPS[tov].description,
      tovLabel: PRESET_TONE_OF_VOICE_PROPS[tov].label,
    };
  } else {
    const customTov = customToneOfVoices.find((customTov) => customTov.id === tov);
    return {
      tovTitle: customTov?.name,
      tovDescription: customTov?.description,
      tovLabel: customTov?.brandVoiceName,
    };
  }
};

export const getToneOfVoiceForGeneration = ({
  selectedTov,
  selectedTovType,
  selectedManualTov,
}) => {
  if (selectedTovType === TONE_OF_VOICE_TYPE.manual) {
    return { manualAttributes: selectedManualTov };
  } else if (isPresetTov(selectedTov)) {
    return { defaultPreset: selectedTov };
  } else {
    return { customId: selectedTov };
  }
};

export const getToneOfVoiceForInfinity = (
  { selectedTov, selectedTovType, selectedManualTov },
  customToneOfVoices
) => {
  if (!selectedTov && !selectedTovType.length) {
    return;
  }
  if (selectedTovType === TONE_OF_VOICE_TYPE.manual) {
    return selectedManualTov
      .map((manualTov) => MANUAL_TONE_OF_VOICE_PROPS[manualTov]?.title)
      .join(', ');
  } else {
    const { tovTitle } = getTovTexts(selectedTov, customToneOfVoices);
    return tovTitle;
  }
};

export const getToneOfVoiceFromGeneration = (tovInput, generationCustomModelId) => {
  if (generationCustomModelId) {
    return {
      selectedCustomModelId: generationCustomModelId,
      selectedTov: null,
      selectedTovType: TONE_OF_VOICE_TYPE.presets,
      selectedManualTov: EMPTY_MANUAL_TONE_OF_VOICE,
    };
  }
  if (tovInput?.manualAttributes?.length) {
    return {
      selectedCustomModelId: null,
      selectedTov: DEFAULT_SUGGEST_TOV_MODE,
      selectedTovType: TONE_OF_VOICE_TYPE.manual,
      selectedManualTov: tovInput?.manualAttributes,
    };
  }
  return {
    selectedCustomModelId: null,
    selectedTov: tovInput?.customId || tovInput?.defaultPreset || DEFAULT_SUGGEST_TOV_MODE,
    selectedTovType: TONE_OF_VOICE_TYPE.presets,
    selectedManualTov: EMPTY_MANUAL_TONE_OF_VOICE,
  };
};

export const getToneOfVoiceForTrackingEvent = (tovInput) => {
  if (tovInput?.manualAttributes?.length) {
    return {
      tovType: TONE_OF_VOICE_TYPE.manual,
      tov: tovInput?.manualAttributes.join(', '),
    };
  }
  return {
    tov: tovInput?.customId ? 'custom_tov' : tovInput?.defaultPreset || DEFAULT_SUGGEST_TOV_MODE,
    tovType: TONE_OF_VOICE_TYPE.presets,
  };
};
